import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

export const LanguageSwitcher = ({ compact }) => {
  const { lang, setLang } = useI18n();
  const { user, setUser } = useAuth();
  const choose = async (next) => {
    setLang(next);
    if (!user) return;
    try {
      const { data } = await api.patch("/me/account", { locale: next });
      setUser((current) => current ? { ...current, ...data.user } : current);
    } catch { /* The immediate local language choice remains usable offline. */ }
  };
  return (
    <div className="inline-flex rounded-full border border-[var(--pc-border)] p-1" data-testid="language-switcher">
      {["en", "de"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => choose(l)}
          className="pc-btn"
          style={{
            padding: compact ? "4px 12px" : "6px 16px", fontSize: 13,
            background: lang === l ? "var(--pc-cyan)" : "transparent",
            color: lang === l ? "#001014" : "var(--pc-muted)",
          }}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
